"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDatasetSharingActionWatcher = void 0;
const effects_1 = require("redux-saga/effects");
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const datasets_1 = require("companion-app-components/flux/datasets");
const actions_1 = require("components/Dialogs/DatasetSharing/actions");
function* handleDatasetSharedCreatedAction({ payload }) {
    const datasets = yield (0, effects_1.select)(datasets_1.datasetsSelectors.getDatasetsById);
    const datasetName = datasets.get(payload.datasetId).name;
    yield (0, effects_1.put)((0, actions_1.showInviteSentDialog)({
        name: `${payload.granteeFirstName} ${payload.granteeLastName}`,
        datasetName,
    }));
}
function* createDatasetSharingActionWatcher() {
    yield (0, effects_1.takeEvery)([dataset_shares_1.datasetSharesActions.createDatasetShareSuccess], handleDatasetSharedCreatedAction);
}
exports.createDatasetSharingActionWatcher = createDatasetSharingActionWatcher;
exports.default = [createDatasetSharingActionWatcher];
